(function ($) {
  'use strict';
  var trackedAnswers = [];

  this.Strava2023.Contest = function () {
    $(document).on(
      'click touchstart',
      'button.strava_2023-submit-newsletter',
      this.newsletter.bind(this)
    );
  };

  this.Strava2023.Contest.prototype.newsletter = function (e) {
    var t = this;
    var button = $(e.currentTarget);
    var screen = button.closest('.screen');
    var error = 0;

    screen.find('.error').slideUp(0);
    console.log(screen);
    var email = screen.find('input.mail').val();
    if (!email) {
      screen.find('.empty-email').slideDown();
      error = 1;
    }

    var news = screen.find('input.news').is(':checked');
    if (!news) {
      screen.find('.agreement').slideDown();
      error = 1;
    }

    if (error) {
      return false;
    }
    button.addClass('loading').attr('disabled', true);

    $.ajax({
      method: 'POST',
      url: window.ys.rest_url + 'uci2023/v1/subscribe/',
      data: {
        action: 'news',
        email: email,
        page_id: button.attr('data-page-id'),
      },
      dataType: 'json',
      success: function (resp) {
        var response = JSON.parse(resp);
        button.removeClass('loading').attr('disabled', false);

        if (response.error) {
          if (response.error === 'invalid-email') {
            screen.find('.invalid-email').slideDown();
            return false;
          }

          screen.find('.general').slideDown();
          return false;
        }

        $('.container-subscription').fadeOut(0);
        $('#newsletter-success-title').fadeIn();

        t.gaEvent('Opted-in', 'Newsletter');
      },
    });
  };
}).bind(window)(jQuery);
